export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";